const roleMap = {
  producer: 'producer',
  property_agent: 'propertyAgent',
  contact_agent: 'contactAgent',
  owner: 'owner',
  doorman: 'doorman',
  key_agent: 'keyAgent',
  agent: 'agent',
  user: 'user',
};

function parseSingleAgent(agent) {
  return {
    id: agent.id || roleMap[agent.role],
    role: roleMap[agent.role],
    email: agent.email,
    name: agent.name_surname,
    thumbnail: agent.photo,
    isFixed: true,
    required: agent.required,
    isAnonymous: !agent.id,
    hasTheKeys: agent.has_the_keys,
    validEmail: agent.is_valid_email_account,
  };
}

export function parseFixedParticipants({
  producer,
  propertyAgent,
  contactAgent,
  owner,
  doorman,
  keyAgent,
}) {
  const agentsArray = [producer, propertyAgent, contactAgent, owner];

  const fixedParticipants = Object.fromEntries(
    agentsArray.map((agent) => [roleMap[agent.role], parseSingleAgent(agent)])
  );

  if (doorman) {
    // doorman is a contact but the data structure is the same than an agent
    fixedParticipants.doorman = parseSingleAgent(doorman);
  }

  if (keyAgent) {
    fixedParticipants.keyAgent = parseSingleAgent(keyAgent);
  }

  return fixedParticipants;
}

export function parseExtraAgents(extraAgents) {
  return extraAgents.map((agent) => ({
    id: agent.id,
    role: 'user',
    email: agent.email,
    name: agent.name_surname,
    validEmail: agent.is_valid_email_account,
    thumbnail: agent.photo,
    isFixed: false,
    required: true,
    isAnonymous: !agent.id,
  }));
}

export function parseExtraContacts(extraContacts) {
  return extraContacts.map((contact) => ({
    id: contact.id,
    role: 'contact',
    email: contact.email,
    name: contact.name,
    thumbnail: contact.photo,
    isFixed: false,
    required: true,
    isAnonymous: !contact.id,
  }));
}

export function parseAddedAgent(agent) {
  return {
    id: agent.id,
    role: 'user',
    email: agent.email,
    name: agent.full_name,
    thumbnail: agent.profile_image,
    validEmail: agent.is_valid_email_account,
    isFixed: false,
    required: true,
    isAnonymous: false,
  };
}

export function parseAddedContact(contact) {
  return {
    id: contact.id,
    role: 'contact',
    email: contact.contact_info?.email,
    name: contact.name,
    thumbnail: contact.picture,
    isFixed: false,
    required: true,
    isAnonymous: false,
  };
}

export function parseCreatedContact(contact) {
  return {
    id: contact.id,
    role: 'contact',
    email: contact.email,
    name: contact.name,
    thumbnail: null,
    isFixed: false,
    required: true,
    isAnonymous: false,
  };
}
